import { useHistory } from 'react-router';
import { Spinner } from '../../components/common';
import { ROUTE_PATH } from '../../routes/paths';
import Header from '../../components/common/global-top-bar';
import { connect, useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import { fetchTosRequest, updateTosRequest } from './text-blocks-redux/actions';
import RichTextEditor from '../../components/rich-text-editor/rich-text-editor';
import { Location } from 'history';
import { TextBlocksHeaderOptions } from './common/text-blocks-constants';
import SwitchBar from '../../components/switch-bar';
import RouteLeavingGuard from '../../components/route-leaving-prompt';

type props = {
  pending: boolean;
  listenerFaq: any;
  peersFaq: any;
};

const ListenerFaqTOS: React.FunctionComponent<props> = ({ pending, listenerFaq, peersFaq }): JSX.Element => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [richText, setRichText] = useState({
    listenerFaq: '',
    peersFaq: '',
    listenerFaqSave: true,
    peersFaqSave: true,
  });

  const handleSave = (messageType: string, data: any) => {
    const payload = {
      type: messageType,
      payload: {
        value: data,
      },
    };
    dispatch(updateTosRequest(payload));
  };

  const handleMessage = (messageType: string, data: any, fromRedux?: boolean) => {
    setRichText((richtext: any) => ({
      ...richtext,
      [messageType]: data,
      [messageType + 'Save']: fromRedux ? true : false,
    }));
  };

  useEffect(() => {
    if (listenerFaq?.status === 200) {
      handleMessage('listenerFaq', listenerFaq.data?.LISTENER_FAQ, true);
    }
  }, [listenerFaq]); //

  useEffect(() => {
    if (peersFaq?.status === 200) {
      handleMessage('peersFaq', peersFaq.data?.PEER_FAQ, true);
    }
  }, [peersFaq]); //peersFaq

  useEffect(() => {
    dispatch(fetchTosRequest({ type: 'LISTENER_FAQ' }));
    dispatch(fetchTosRequest({ type: 'PEER_FAQ' }));
  }, []);

  return (
    <div>
      {pending && <Spinner />}
      <RouteLeavingGuard
        when={!richText.listenerFaqSave || !richText.peersFaqSave}
        navigate={(path: string) => history.push(path)}
        shouldBlockNavigation={(location: Location) => {
          if (!richText.listenerFaqSave || !richText.peersFaqSave) {
            if (location.pathname !== ROUTE_PATH.LISTENRFAQTOC) {
              return true;
            }
          }
          return false;
        }}
        titleText={'Alert'}
        contentText={'You have unsaved changes. Do you want to leave this page and lose your changes?'}
        cancelButtonText={'Cancel'}
        confirmButtonText={'Continue and lose changes'}
      />
      <Header heading={'Listeners'} />
      <SwitchBar heading={TextBlocksHeaderOptions} position={2} />

      <div className="max-window-height overflow-y-auto pb-32 pt-4">
        <div>
          <div className="mt-4 w-full px-7">
            <div className="flex items-end justify-between border-b border-gray-500 py-2">
              <p className="text-gray-dark pt-4 font-bold">LISTENERS FAQ</p>
              <button
                className="stacked-bar-blue-400 h-6 rounded-full px-2 text-center text-sm text-white disabled:bg-gray-400"
                onClick={() => {
                  handleSave('LISTENER_FAQ', richText.listenerFaq);
                }}
                disabled={richText.listenerFaqSave}
              >
                SAVE
              </button>
            </div>
            <div className="mt-4">
              <RichTextEditor
                content={richText?.listenerFaq}
                onChange={(value) => handleMessage('listenerFaq', value)}
                key={`listener-faq`}
                data-testid="listener-faq-editor"
              />
            </div>
          </div>
          <div className="mt-4 w-full px-7">
            <div className="flex items-end justify-between border-b border-gray-500 py-2">
              <p className="text-gray-dark pt-4 font-bold">PEER FAQ </p>
              <button
                className="stacked-bar-blue-400 h-6 rounded-full px-2 text-center text-sm text-white disabled:bg-gray-400"
                onClick={() => {
                  handleSave('PEER_FAQ', richText.peersFaq);
                }}
                disabled={richText.peersFaqSave}
              >
                SAVE
              </button>
            </div>
            <div className="mt-4">
              <RichTextEditor
                content={richText?.peersFaq}
                onChange={(value) => handleMessage('peersFaq', value)}
                key={`peers-faq`}
                data-testid="peers-faq-editor"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    pending: state.Tos?.pending || null,
    listenerFaq: state.Tos.listenerFaq || null,
    peersFaq: state.Tos.peersFaq || null,
  };
};

export default connect(mapStateToProps)(ListenerFaqTOS);
